import React from 'react';
import ListRollNo from './List_Roll_Numbers';
import '../../../CommonCSS/SocietyCSS.css'

const ListRollNoApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Roll Number Listings</h5>
          </div>
        </div>
        <ListRollNo />
      </div>
    </div >
  );
};

export default ListRollNoApp;
